import {
  Heading,
  Card,
  CardBody,
  Container,
  CardHeader,
  Button,
  SimpleGrid,
  Box,
  Modal,
  ModalBody, ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Select,
  Stack
} from "@chakra-ui/react";
import DashboardMenu from "./components/dashboardMenu/DashboardMenu";
import MyBreadcrumb from "components/breadcrumb/Breadcrumb";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Document } from "types/Document";
import { useAppDispatch } from "store/store.hook";
import { FaFile, FaUsers } from "react-icons/fa6";
import { getAttributesByType } from "service/api/attributes.api";
import { getDocuments } from "service/api/document.api";
import { getRoles } from "service/api/role.api";
import { getUsers } from "service/api/user.api";
import { addAttributesAnvur, addAttributesPnrr, addAttributesSdg } from "store/reducers/attribute.slice";
import { addUsers, removeUserLogout } from "store/reducers/auth.slice";
import { addDocuments, resetDocumentsState, resetSelectedDocumentId, setSelectedDocumentId } from "store/reducers/documents.slice";
import { addRoles } from "store/reducers/role.slice";
import { FaArchive, FaDiceD6 } from "react-icons/fa";
import { getAllDocumentsHistories } from "service/api/document.history.api";
import { addDocumentsHistories } from "store/reducers/documents.histories";
import { getSources } from "service/api/sources.api";
import { addSources } from "store/reducers/sources.slice";
import { getDivisions } from "service/api/divisions.api";
import { addDivisions } from "store/reducers/divisions.slice";
import { Breadcrumb } from "types/Breadcrumb";
import { getOrganizationalUnits } from "service/api/organizational.units";
import { addOrganizationalUnits } from "store/reducers/organizational.units.slice";

/**
 * Dashboard component that displays the main dashboard view for the admin.
 * It includes a modal for selecting a document, a breadcrumb navigation, and
 * sections for monitoring and configuration.
 *
 * @component
 * @returns {JSX.Element} The rendered Dashboard component.
 *
 * @example
 * <Dashboard />
 *
 * @remarks
 * This component uses Chakra UI for styling and layout, and Redux for state management.
 * It fetches various data such as documents, roles, users, attributes, organizational units,
 * sources, document histories, and divisions on mount if the user is authenticated.
 *
 * @function
 * @name Dashboard
 *
 * @hook
 * @name useAppDispatch
 * @description Hook to dispatch actions to the Redux store.
 *
 * @hook
 * @name useSelector
 * @description Hook to access the Redux store's state.
 *
 * @hook
 * @name useDisclosure
 * @description Hook to control the modal's open and close state.
 *
 * @state {string} documentId - The ID of the selected document.
 *
 * @event handleOnChangeDocument - Event handler for changing the selected document.
 * @param {React.ChangeEvent<HTMLSelectElement>} event - The change event.
 *
 * @event handleOnSubmit - Event handler for submitting the selected document.
 * @param {React.FormEvent<HTMLFormElement>} event - The form submit event.
 *
 * @event onClickHandlerLogout - Event handler for logging out the user.
 *
 */

export default function Dashboard() {
  const dispatch = useAppDispatch();
  const isUserAdmin = useSelector((state: any) => state.user?.user?.isAdmin);
  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: true })
  const documents = useSelector((state: any) => state.documents.documents);
  const selectedDocumentId = useSelector((state: any) => state.documents.selectedDocumentId);
  const [documentId, setDocumentId] = useState<string>("");
  const user = useSelector((state: any) => state.user.user);
  const documentInEditing = useSelector((state: any) => state.documents?.documentInEditing);

  useEffect(() => {
    if (user) {
      getDocuments().then((res) => {
        dispatch(addDocuments(res));
      });
      getRoles().then((res) => {
        dispatch(addRoles({ roles: res }));
      });
      getUsers().then((res) => {
        dispatch(addUsers({ users: res }));
      });
      getAttributesByType("pnrr").then((res) => {
        dispatch(addAttributesPnrr({ attributesPnrr: res }));
      });
      getAttributesByType("sdg").then((res) => {
        dispatch(addAttributesSdg({ attributesSdg: res }));
      });
      getAttributesByType("anvur").then((res) => {
        dispatch(addAttributesAnvur({ attributesAnvur: res }));
      });
      getOrganizationalUnits().then((res) => {
        dispatch(addOrganizationalUnits({ organizationalUnits: res }));
      });
      getSources(false).then((res: any) => {
        dispatch(addSources({ sources: res }));
      });
      getAllDocumentsHistories().then((res: any) => {
        dispatch(addDocumentsHistories({ documents: res }));
      });
      getDivisions().then((res: any) => {
        dispatch(addDivisions({ divisions: res }))
      })

    }

    if (documentInEditing?._id == selectedDocumentId) {

      //TODO: 
      // dispatch(
      //   addTargets({
      //   targets: documentInEditing?.targets,
      //   title: documentInEditing?.title,
      //   code: documentInEditing?.code,
      //   timePeriods: documentInEditing?.timePeriods,
      //   _id: documentInEditing?._id,
      //   isActive: documentInEditing?.isActive ?? false,
      // }));

    }

  }, [])

  const handleOnChangeDocument = (event: any) => {
    setDocumentId(event.target.value);
  }

  const handleOnSubmit = (event: any) => {
    event.preventDefault();
    if (documentId) {
      const document = documents.find((document: Document) => document._id === documentId);
      dispatch(setSelectedDocumentId({ documentId: document._id }))

      onClose();
    }
  }


  const onClickHandlerLogout = () => {
    alert("Logout effettuato con successo!");
    dispatch(removeUserLogout());
    dispatch(resetDocumentsState());
    dispatch(resetSelectedDocumentId());
  };



  return (
    <>
      {
        (selectedDocumentId == null || selectedDocumentId == "") &&
        <Modal blockScrollOnMount={true} isOpen={isOpen} onClose={onClose} size={"2xl"} closeOnOverlayClick={false} closeOnEsc={false}>
          <ModalOverlay backdropFilter='blur(5px)' />
          <form onSubmit={handleOnSubmit}>
            <ModalContent>
              <ModalHeader>Seleziona il documento</ModalHeader>
              <ModalBody>
                <Stack spacing={3}>
                  <Select required={true}
                    placeholder={"Seleziona documento"}
                    onChange={handleOnChangeDocument}

                  >
                    {documents?.map((document: Document, index: number) => {
                      return (
                        <option key={`dcmnt-${index}`} value={document._id}>
                          {document?.title} - {document?.code} - {document?.createdAt}
                        </option>
                      );
                    })}
                  </Select>
                </Stack>
              </ModalBody>

              <ModalFooter>

                <Button colorScheme='red' mr={3} onClick={onClickHandlerLogout} variant={"outline"}>
                  Logout
                </Button>

                <Button colorScheme='blue' mr={3} type="submit">
                  Seleziona documento
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </Modal>
      }


      <section className="dashboard-first-section">
        <Container maxW="container.lg" maxH={"container.xl"}>
          <MyBreadcrumb />

          <Card>
            <CardHeader>
              <Heading as="h1" size="3xl" textAlign={"left"}>
                Monitoraggio Terza Missione
              </Heading>
            </CardHeader>
            <CardBody>
              <DashboardMenu
                targets={
                  documents.find((document: Document) => document._id === selectedDocumentId)?.targets.slice(0, 7)
                }
              />
            </CardBody>
          </Card>
        </Container>
      </section>

      {
        isUserAdmin &&
        <section className="dashboard-second-section">
          <Container maxW="container.lg" maxH={"container.xl"}>
            <Card>
              <CardHeader>
                <Heading as="h2" size="2xl" textAlign={"left"}>
                  Configurazione
                </Heading>
              </CardHeader>
              <CardBody>
                <SimpleGrid columns={4} spacing={10} m={0} p={0}>
                  <Box>
                    <Link to="/roles">
                      <Button
                        leftIcon={<FaUsers />}
                        colorScheme="yellow"
                        variant="solid"
                        w="full"
                      >
                        Gestione Utenti e Ruoli
                      </Button>
                    </Link>
                  </Box>
                  <Box>
                    <Button
                      leftIcon={<FaFile />}
                      colorScheme="cyan"
                      variant="solid"
                      w="full"
                      isDisabled={false}
                      as={Link}
                      to="/documents"
                    >
                      Gestione Documenti
                    </Button>
                  </Box>
                  <Box>
                    <Button
                      leftIcon={<FaDiceD6 />}
                      colorScheme="purple"
                      variant="solid"
                      w="full"
                      isDisabled={false}
                      as={Link}
                      to="/sources"
                    >
                      Gestione Fonti
                    </Button>
                  </Box>
                  <Box>
                    <Button
                      leftIcon={<FaArchive />}
                      colorScheme="green"
                      variant="solid"
                      w="full"
                      isDisabled={false}
                      as={Link}
                      to="/archive"
                    >
                      Archivio
                    </Button>
                  </Box>
                </SimpleGrid>
              </CardBody>
            </Card>
          </Container>
        </section>
      }
    </>
  );
}
